import Icon from "@mui/material/Icon";
import client from "../src/assets/sidebarLogo/clients.png";
import projects from "../src/assets/sidebarLogo/projects.png";
import qualification from "../src/assets/sidebarLogo/qualification.png";
import survey from "../src/assets/sidebarLogo/survey.png";
import vendor from "../src/assets/sidebarLogo/vendor.png";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import SortIcon from '@mui/icons-material/Sort';

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
  },

  {
    type: "title",
    name: "Projects",
    key: "projects",
    icon: <Icon fontSize="small">assessment_icon</Icon>,
    collapse: [
      {
        name: "Surveys",
        key: "surveys",
        route: "/surveys",
        icon: survey,
      },
      {
        name: "Projects",
        key: "projects",
        route: "/projects",
        icon: projects,
      },
    ],
  },
  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    icon: <Icon fontSize="small">descriptionoutlinedicon</Icon>,
    route: "/reports",
  },
  {
    type: "title",
    name: "Generic Report",
    key: "genericReport",
    icon: <Icon fontSize="small">summarizeicon</Icon>,
    route: "/genericReports",
    collapse: [
      {
        name: "Generic Report",
        key: "genericReport",
        route: "/genericReports",
        icon: survey,
      },
      {
        name: "Report History",
        key: "reportHistory",
        route: "/reportHistory",
        icon: projects,
      },
    ],
  },
  {
    type: "collapse",
    name: "Campaigns",
    key: "campaigns",
    icon: <Icon fontSize="small">campaignicon</Icon>,
    route: "/campaigns",
  },
  {
    type: "title",
    name: "Admin",
    key: "admin",
    icon: <Icon fontSize="small">personoutlineOutlinedicon</Icon>,
    collapse: [
      {
        name: "Vendors",
        key: "vendors",
        route: "/vendors",
        icon: vendor,
      },
      {
        name: "Clients",
        key: "clients",
        route: "/clients",
        icon: client,
      },
      {
        name: "Qualification",
        key: "qualification",
        route: "/qualification",
        icon: qualification,
      },
      // {
      //   name: "User Mangment",
      //   key: "userMangment",
      //   icon: <Icon fontSize="small">api</Icon>,
      //   route: "/userMangment",
      //   component: <ApiSurvey />,
      // },
    ],
  },
  // {
  //   type: "collapse",
  //   name: "Configurations",
  //   key: "configurations",
  //   icon: <SettingsSuggestIcon fontSize="small" />,
  //   route: "/configurations",
  // },
  {
    type: "collapse",
    name: "GlobalReconciliation",
    key: "globalReconciliation",
    icon: <Icon fontSize="medium">language_icon</Icon>,
    route: "/globalReconciliation",
  },
  {
    type: "collapse",
    name: "Surveys Priority",
    key: "surveys-priority",
    icon: <SortIcon fontSize="medium" />,
    route: "/surveys-priority",
  },

  {
    type: "collapse",
    name: "Router Configurations",
    key: "router-configurations",
    icon: <Icon fontSize="medium">settings</Icon>,
    route: "/router-configurations/client-priority",
  },
];

export default routes;
